module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-300.c44e2d96.eot";